import { Container, Paper, Button } from "@mantine/core";
import { useContext } from "react";
import { useForm } from "react-hook-form";
import { Textarea, TextInput } from "react-hook-form-mantine";
import { AuthContext } from "../../services/context";
import { getCurrentWorkspace } from "../../services/userConfig";
import { useCreateSpeaker } from "../../api/speakers";
import ImageUpload from "../ImageUpload";
import { web_createSpeakerSchema } from "@congrs/schemas";
import resolver from "@congrs/resolver";
import ExternalLinksInput from "../ExternalLinksInput";

function Create() {
  const { user } = useContext(AuthContext);
  const { eventId } = getCurrentWorkspace(user);

  const defaultValues = {
    firstName: "",
    lastName: "",
    occupation: "",
    biography: "",
    eventId,
  };

  const { setValue, control, handleSubmit, reset } = useForm({
    defaultValues,
    resolver: resolver(web_createSpeakerSchema),
  });

  const { mutate, isPending } = useCreateSpeaker();

  const onSubmit = (data) => {
    mutate(data, {
      onSuccess: () => {
        reset(defaultValues);
      },
    });
  };

  return (
    <Container w={600}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Paper withBorder shadow="sm" px="sm" py="md" style={{ marginTop: 20 }}>
          <ImageUpload
            control={control}
            name="picture"
            label="Profile picture"
            description="The picture should not be larger than 5MB."
            mb="sm"
            resize
          />

          <TextInput
            label="First Name"
            placeholder="John"
            name="firstName"
            control={control}
            withAsterisk
          />
          <TextInput
            label="Last Name"
            placeholder="Doe"
            name="lastName"
            control={control}
            withAsterisk
            mt="sm"
          />
          <TextInput
            label="Occupation"
            placeholder="Software Engineer at RoundCube"
            name="occupation"
            control={control}
            mt="sm"
          />
          <Textarea
            label="Biography"
            placeholder="Tell us about the speaker"
            name="biography"
            control={control}
            autosize
            minRows={3}
            mt="sm"
          />

          <ExternalLinksInput
            control={control}
            setValue={setValue}
            name="links"
            mt="md"
          />

          <Button
            type="submit"
            color="blue"
            style={{ marginTop: 20 }}
            loading={isPending}
          >
            Create speaker
          </Button>
        </Paper>
      </form>
    </Container>
  );
}

export default Create;
